export default "__VITE_ASSET__zl1eq$Bc__"